import { brand } from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const ItemList = styled.div `
  --avatarBorder: 8px;
  --avatarSize: 128px;
  --avatarTotalSize: calc(var(--avatarSize) + (var(--avatarBorder) * 2));
  display: grid;
  gap: 90px 0;
  grid-template-columns: repeat(12, 1fr);
  margin-top: var(--sectionMargin);
  padding-top: calc(var(--avatarTotalSize) / 2);  

  @media ${from(Device.MobileLarge)} {
    --avatarBorder: 10px;
    --avatarSize: 200px;
    gap: 150px 0;
  }

  @media ${from(Device.Tablet)} {
    --avatarBorder: 12px;
    --avatarSize: 280px;
    gap: 200px 0;
  }

  @media ${from(Device.TabletLarge)} {
    margin: 32px -16px 0;
  }

  @media ${from(Device.DesktopSmall)} {
    gap: 200px 0;
    justify-content: center;
    margin-top: 20px;
    transition: none;
  }
`;
const Item = styled.div `
  grid-column: span 12;

  &:nth-child(odd) {
    --accentColor: ${brand.green.beige};
  }

  &:nth-child(even) {
    --accentColor: ${brand.green.seafoam};
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 6;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: span 4;
  }
`;
export default {
    Item,
    ItemList,
};
